<template>
<a href="/overseas.html?type=nav" :class="current" :data-scp="scp">
	<i class="icon icon-index_worldwide"></i><span v-text="text"></span>
</a>
</template>

<script>
import domain from "../../domain";

export default {
	props: {
		current: String
		, scp: String
		, text: {
			type: String
			, default: '海外购'
		}
	},
    methods: {
        getOverSeaUrl() {
            let contentId = 1857;
            if (domain.env === 'test') {
                contentId = 201;
            } else if (domain.env === 'pre') {
                contentId = 33;
            }
            return `/activity.html#/index?contentId=${contentId}`;
        }
    }
}
</script>